/** @deprecated */
export enum ApplicationStatus {
  OfferSelection = 'Offer Selection',
  CompletingVerification = 'Completing Verification',
  ManualReview = 'Manual Review',
  SigningDocuments = 'Signing Documents',
  Funding = 'Funding',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Canceled = 'Canceled',
}
/** @deprecated */
export enum ECOAConsentType {
  First = 'ecoa_consent_option_1_complete',
  Second = 'ecoa_consent_option_2_complete',
}
/** @deprecated */
export enum StageType {
  EmailVerificationComplete = 'email_verification_complete',
  BankAccountVerificationComplete = 'bank_account_verification_complete',
  IncomeVerificationComplete = 'income_verification_complete',
  SubmitApplicationComplete = 'submit_Application_complete',
}
/** @deprecated */
export enum BaseApplicationKeyInformationType {
  FirstName = 'borrower_first_name',
  LastName = 'borrower_last_name',
  EmailAddress = 'borrower_email',
  Phone = 'borrower_phone',
  ManualReviewRequired = 'manual_review_required',
  SigningDocumentComplete = 'signing_document_complete',
  FundingComplete = 'funding_complete',
  FundingCompleteDate = 'funding_complete_date',
  LastFourDigitsOfBankAccountNumber = 'last_4_digits_of_bank_account_number',
  ConsumerReportsConsentComplete = 'consumer_reports_consent_complete',
  EmployerName = 'employer_name',
  EquifaxFICOScore = 'equifax_fico_score',
  FinalCreditUnderwritingCompleteDate = 'final_credit_underwriting_complete_date',
  APR = 'apr',
  MonthlyPayment = 'monthly_payment',
  NumberOfPayments = 'number_of_payments',
  AmountFinanced = 'amount_financed',
  CalculateLoanComplete = 'calculate_loan_complete',
  CalculateLoanCompleteDate = 'calculate_loan_complete_date',
  BorrowerStateOrProvince = 'borrower_state_or_province',
  BranchNumber = 'branch_number',
  BranchName = 'branch_name',
  BranchAddress = 'branch_address',
  BranchCity = 'branch_city',
  BranchState = 'branch_state',
  BranchZipCode = 'branch_zip_code',
  BranchPhone = 'branch_phone',
  BranchHours = 'branch_hours',
  IncomeSourcesSelected = 'income_sources_selected',
  IncomeVerificationComplete = 'income_verification_complete',
  AutomatedFraudCheckComplete = 'automated_fraud_check_complete',
  BankAccountVerificationComplete = 'bank_account_verification_complete',
  BankAccountVerificationSkipped = 'bank_account_verification_skipped',
  BankInformationManualReview = 'bank_information_manual_review',
  BankOrIncomeDocumentsUploaded = 'bank_or_income_documents_uploaded',
  FinalOnlineOfferEstimatedPayment = 'final_online_offer_estimated_payment',
  FinalOnlineOfferRate = 'final_online_offer_rate',
  FinalOnlineOfferLoanAmount = 'final_online_offer_loan_amount',
  FinalOnlineOfferFundedTerm = 'final_online_offer_funded_term',
  FinalOnlineOfferStatus = 'final_online_offer_status',
  OnlineOfferAvailable = 'online_offer_available',
  PrequalOfferLoanAmount = 'prequal_offer_loan_amount',
  PrequalOfferEstimatedPayment = 'prequal_offer_estimated_payment',
}
/** @deprecated */
export enum IncomeSourceType {
  EmployeeSalaryOrWagesIncome = 'employee_salary_or_wages_income',
  SelfEmployedIncome = 'self_employed_income',
  GovernmentBenefitsIncome = 'government_benefits_income',
  ChildSupportOrAlimonyIncome = 'child_support_or_alimony_income',
  RentalPropertyIncome = 'rental_property_income',
}
/** @deprecated */
export enum State {
  Alabama = 'AL',
  Georgia = 'GA',
  Kentucky = 'KY',
  Louisiana = 'LA',
  Missouri = 'MO',
  Mississippi = 'MS',
  SouthCarolina = 'SC',
  Texas = 'TX',
  Tennessee = 'TN',
  Ohio = 'OH',
}
